// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"0c684e5a","205":"4cfcb710","231":"d1e650d5","459":"ec9d70d9","645":"a13a5ffa","923":"349e9b11","929":"3194b84f","937":"de41546c"}[chunkId] + ".chunk.js";
};